import { useApiClient } from 'bff/ApiClientProvider';
import { queryOptions } from '@tanstack/react-query';
import { ReportingGetBeneficiariesRequest } from 'bff/client';

export const getBeneficiaries = (request: ReportingGetBeneficiariesRequest) => {
  const { reportingApi } = useApiClient();

  return queryOptions({
    queryKey: ['beneficiaries'],
    queryFn: () => reportingApi.reportingGetBeneficiaries(request),
    select: (response) => response.data?.beneficiariesList
  });
};
